import { getApp, getApps, initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectDatabaseEmulator, getDatabase } from "firebase/database";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
// Replace these placeholders with the Web app configuration from
// Firebase Console > Project settings > Your apps.
export const firebaseConfig = {
    apiKey: "AIzaSyCw__mcoj6Mtwnbqef6cZcqBJ5jTVH9rZ0",
    authDomain: "my-track-and-field-team-c3892.firebaseapp.com",
    projectId: "my-track-and-field-team-c3892",
    storageBucket: "my-track-and-field-team-c3892.appspot.com",
    messagingSenderId: "320709830380",
    appId: "1:320709830380:web:92456b90540946c251e7c9",
    databaseURL: "https://my-track-and-field-team-c3892.firebaseio.com",
    //databaseURL: "https://my-track-and-field-team-testing.firebaseio.com",
};
//const host = '127.0.0.1';
const host = '192.168.1.211';
export const emulatorConfig = {
    enabled: process.env.NODE_ENV === "development",
    authUrl: `http://${host}:9099`,
    firestoreHost: host,
    firestorePort: 8080,
    realtimeDatabaseHost: host,
    realtimeDatabasePort: 9000,
    storageHost: host,
    storagePort: 9199,
    functionsHost: host,
    functionsPort: 5001,
};
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
export const storage = getStorage(app);
export const cloudFunctions = getFunctions(app);
if (emulatorConfig.enabled) {
    connectAuthEmulator(auth, emulatorConfig.authUrl, { disableWarnings: true });
    connectFirestoreEmulator(db, emulatorConfig.firestoreHost, emulatorConfig.firestorePort);
    connectDatabaseEmulator(realtimeDb, emulatorConfig.realtimeDatabaseHost, emulatorConfig.realtimeDatabasePort);
    connectStorageEmulator(storage, emulatorConfig.storageHost, emulatorConfig.storagePort);
    connectFunctionsEmulator(cloudFunctions, emulatorConfig.functionsHost, emulatorConfig.functionsPort);
}
export default app;
